<template>
  <CFooter>
    <div>
      <a href="https://www.centroid3d.com/" target="_blank">Centroid motion capture</a>
      <span class="ms-1"
        >&copy; {{ new Date().getFullYear() }} </span
      >
    </div>
    <div class="ms-auto">
      <span class="me-1" target="_blank">Powered by</span>
      <a href="https://www.centroid3d.com/">Centroid motion capture</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>
